import { render, staticRenderFns } from "./ModalVisualizarDados.vue?vue&type=template&id=0bf21863&scoped=true"
import script from "./ModalVisualizarDados.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVisualizarDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalVisualizarDados.vue?vue&type=style&index=0&id=0bf21863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf21863",
  null
  
)

export default component.exports